const STORAGE_KEY = 'chessvision-board:engine-enabled';
const SELECTION_STORAGE_KEY = 'chessvision-board:engine-selection';

export function readEnginePreference(fallback, rememberEnabled) {
  if (!rememberEnabled) return fallback;

  try {
    const saved = window.localStorage.getItem(STORAGE_KEY);

    if (saved === 'true') return true;
    if (saved === 'false') return false;
  } catch {
    // Storage may be unavailable inside an iframe.
  }

  return fallback;
}

export function saveEnginePreference(engineOn, rememberEnabled) {
  if (!rememberEnabled) return;

  try {
    window.localStorage.setItem(STORAGE_KEY, String(engineOn));
  } catch {
    // Keep the toggle working even when storage is blocked.
  }
}

export function readEngineSelection(fallback = 'classic', rememberSelection = true) {
  const defaultEngine = fallback === 'nnue' ? 'nnue' : 'classic';
  if (!rememberSelection) return defaultEngine;

  try {
    const saved = window.localStorage.getItem(SELECTION_STORAGE_KEY);
    if (saved === 'classic' || saved === 'nnue') return saved;
  } catch {
    // Storage may be unavailable inside an iframe.
  }

  return defaultEngine;
}

export function saveEngineSelection(engine, rememberSelection = true) {
  if (!rememberSelection || !['classic', 'nnue'].includes(engine)) return;

  try {
    window.localStorage.setItem(SELECTION_STORAGE_KEY, engine);
  } catch {
    // Keep engine selection working even when storage is blocked.
  }
}
